/*问题*/
const Question = r => require.ensure([], () => r(require('@/views/question/')), 'Question')
/*第一步选择体检报告*/
const Selectreport = r => require.ensure([], () => r(require('@/views/question/first-step')), 'Selectreport')
/*近期内无体检报告*/
const ReportNone = r => require.ensure([], () => r(require('@/views/question/report-none')), 'ReportNone')
/*第二步问卷调查*/
const Questionnaire = r => require.ensure([],() => r(require('@/views/question/fill-questionnaire')), 'Questionnaire')
/*健康评估（无记录）*/
const AssessmentNone = r => require.ensure([],() => r(require('@/views/question/assessment-none')), 'AssessmentNone')
/*报告正在生成中*/
const Generating = r => require.ensure([],() =>r(require('@/views/question/generating')), 'Generating')
/*综合评估报告详情*/
const AssessmentDetails = r => require.ensure([],() =>r(require('@/views/question/assessment-details')), 'AssessmentDetails')
/*疾病*/
const Disease = r => require.ensure([],() =>r(require('@/views/question/disease-details')), 'Disease')
/*风险详情*/
const Mammary = r => require.ensure([],() =>r(require('@/views/question/disease-details/mammary-disease')), 'Mammary')
/*患病详情*/
const Hypertension = r => require.ensure([],() =>r(require('@/views/question/disease-details/hypertension-details')), 'Hypertension')
/*异常详情*/
const AbnormalDetails = r => require.ensure([],() =>r(require('@/views/question/disease-details/abnormal-details')), 'AbnormalDetails')
/*往期记录*/
const PassRecord = r => require.ensure([],() =>r(require('@/views/question/past-record')), 'PassRecord')
/*pdf界面*/
const PassRecordPdf = r => require.ensure([],() =>r(require('@/views/question/past-record-pdf')), 'PassRecordPdf')

export default {
  path: '/question',
  component: Question,
  name: 'Question',
  redirect: '/question/fill-questionnaire',
  children: [{
    path: 'fill-questionnaire',
    name: 'questionnaire',
    meta: {
      title: '问卷调查'
    },
    component: Questionnaire
  }, {
    path: 'pass-record',
    name: 'passRecord',
    meta: {
      title: '健康管理记录'
    },
    component: PassRecord
  },{
    path: 'pass-record-pdf',
    name: 'passRecordPdf',
    meta: {
      title: '报告名称'
    },
    component: PassRecordPdf
  },{
    path: 'first-step',
    name: 'selectreport',
    meta: {
      title: '体检报告选择'
    },
    component: Selectreport
  }, {
    path: 'report-none',
    name: 'reportNone',
    meta: {
      title: '体检报告选择'
    },
    component: ReportNone
  }, {
    path: 'assessment-none',
    name: 'assessmentNone',
    meta: {
      title: '健康评估'
    },
    component: AssessmentNone
  }, {
    path: 'generating',
    name: 'generating',
    meta: {
      title: '报告生成中'
    },
    component: Generating
  }, {
    path: 'details',
    name: 'assessmentDetails',
    meta: {
      title: '评估结果'
    },
    component: AssessmentDetails
  }, {
    path: 'disease',
    name: 'disease',
    meta: {
      title: '疾病'
    },
    component: Disease,
    children: [{
      path: 'mammary',
      name: 'mammary',
      meta: {
        title: '风险详情'
      },
      component: Mammary
    }, {
      path: 'hypertension',
      name: 'hypertension',
      meta: {
        title: '患病详情'
      },
      component: Hypertension
    }, {
      path: 'abnormalDetails',
      name: 'abnormalDetails',
      meta: {
        title: '异常详情'
      },
      component: AbnormalDetails
    }]
  }]
}



// WEBPACK FOOTER //
// ./src/views/question/router.js